export default __webpack_public_path__ + "static/media/p2-s3.32f1b699.png";